export default __webpack_public_path__ + "static/video-placeholder-3b5690ed17b0e1dd509675568bbe121a.png";